var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { failure } from '@devexperts/remote-data-ts';
import { combineReader } from '@devexperts/utils/dist/adt/reader.utils';
import { constVoid } from 'fp-ts/lib/function';
import { fromNullable, none, some } from 'fp-ts/lib/Option';
import { ask } from 'fp-ts/lib/Reader';
import { EMPTY, from, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { toRemoteData } from '../../utils/axios';
import { promiseToRD } from '../../utils/object.utils';
import { routes } from '../../utils/routes';
import { jira } from './jira.service';
import { slack } from './slack.service';
import { trello } from './trello.service';
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["Trello"] = "trello";
    IntegrationType["Asana"] = "asana";
    IntegrationType["Jira"] = "jira";
    IntegrationType["ChatHQ"] = "chathq";
    IntegrationType["Slack"] = "slack";
})(IntegrationType || (IntegrationType = {}));
var CompleteConnectResultURI = 'CompleteConnectResult';
export function completeConnectResult(result) {
    return __assign(__assign({}, result), { _URI: CompleteConnectResultURI });
}
export var exporters = combineReader(ask(), trello, jira, slack, function (ctx, trello, jira, slack) {
    var _a;
    var integrationStore = ctx.integrationStore, axios = ctx.axios, _b = ctx.domContext, popContext = _b.popContext, pushContext = _b.pushContext, historyPush = _b.historyPush, getPathname = _b.getPathname;
    var instances = (_a = {},
        _a[IntegrationType.Trello] = trello,
        _a[IntegrationType.Asana] = none,
        _a[IntegrationType.Jira] = some(jira),
        _a[IntegrationType.Slack] = slack,
        _a);
    var getIntegration = function (type) { return instances[type]; };
    var isSupported = function (type) {
        return getIntegration(type).isSome();
    };
    return {
        isSupported: isSupported,
        connect: function (type, projectId, returnRoute, params) {
            getIntegration(type).map(function (integration) {
                pushContext('export.connect', { returnRoute: returnRoute, params: params, projectId: projectId });
                var request = integration.connect();
                if (request.method === 'redirect') {
                    window.location.replace(request.url);
                }
            });
        },
        completeConnect: function () {
            var result = fromNullable(/^\/export\/(.*)$/.exec(getPathname()))
                .chain(function (match) {
                var type = match[1];
                return (getIntegration(type) || none).map(function (integration) { return ({ integration: integration, type: type }); });
            })
                .foldL(function () { return Promise.reject(new Error('Unsupported integration')); }, function (_a) {
                var integration = _a.integration, type = _a.type;
                return integration.completeConnect().then(function (result) { return ({
                    result: result,
                    type: type,
                }); });
            });
            return from(promiseToRD(result)).pipe(switchMap(function (result) {
                return result.fold(EMPTY, EMPTY, function () {
                    historyPush(routes.dashboard);
                    return EMPTY;
                }, function (_a) {
                    var type = _a.type, result = _a.result;
                    var returnParams = { returnRoute: routes.dashboard, params: undefined };
                    var context = popContext('export.connect');
                    if (typeof context === 'object' && context) {
                        if (typeof context.projectId === 'number') {
                            if (typeof context.returnRoute === 'string') {
                                returnParams.returnRoute = context.returnRoute;
                                if (typeof context.params === 'object') {
                                    returnParams.params = context.params;
                                }
                            }
                            var _b = toCompleteConnectResult(result), config = _b.config, secrets = _b.secrets, routeParams = _b.routeParams;
                            var params_1 = __assign(__assign({}, (returnParams.params || {})), (routeParams || {}));
                            return integrationStore
                                .set(context.projectId, type, secrets, config, {})
                                .pipe(tap(function (rd) {
                                return rd.foldL(constVoid, constVoid, function () { return historyPush(returnParams.returnRoute, params_1); }, function (integration) {
                                    return historyPush(returnParams.returnRoute, __assign(__assign({}, params_1), { integrationId: integration.id }));
                                });
                            }));
                        }
                    }
                    return of(failure(new Error())).pipe(tap(function () { return historyPush(routes.dashboard); }));
                });
            }));
        },
        disconnect: function (projectId, integrationId) {
            return integrationStore.remove(projectId, integrationId);
        },
        startExport: function (projectId, integrationId, type, data) {
            switch (type) {
                case IntegrationType.Jira:
                    return toRemoteData(axios.post("/api/products/" + projectId + "/integrations/" + integrationId + "/jira-issues", data));
                case IntegrationType.Trello:
                    return toRemoteData(axios.post("/api/products/" + projectId + "/integrations/" + integrationId + "/trello-cards", data));
                default:
                    return of(failure(new Error('Unsupported integration')));
            }
        },
    };
});
function toCompleteConnectResult(result) {
    if (result && typeof result === 'object' && result._URI === CompleteConnectResultURI) {
        return result;
    }
    else {
        return {
            _URI: CompleteConnectResultURI,
            config: {},
            secrets: result,
        };
    }
}
//# sourceMappingURL=integration.utils.js.map